/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-01 15:50:28
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface PEIManagementListParams {
  examDateStart?: any
  examDateEnd?: any
  employeeName?:any
  current?: any
  size?: any
}

export function getPEIManagementList(
  params: PEIManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspemployeephysicalexam/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}

// 详情
export function getPEIManagementDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspemployeephysicalexam/detail`,
    method: 'GET',
    params
  }
}


// 保存编辑
export interface SubmitParams {
  id?: any
  employeeId?: any
  localId?: any
  sex?: any
  examOrganization?:any
  examContent?: any
  examResult?: any
  humidityAfterMeasure?: any
  examDate?: any
  measures?: any
}

export function getPEIManagementSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspemployeephysicalexam/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspemployeephysicalexam/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
